"use strict";

function t(r, e) {
  return (t = Object.setPrototypeOf || function (t, r) {
    return t.__proto__ = r, t;
  })(r, e);
}

function r() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function e(n, u, o) {
  return (e = r() ? Reflect.construct : function (r, e, n) {
    var u = [null];
    u.push.apply(u, e);
    var o = new (Function.bind.apply(r, u))();
    return n && t(o, n.prototype), o;
  }).apply(null, arguments);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var n = ["hh", "DD", "mm", "ss", "HH"],
    u = {
  YYYY: {
    year: "numeric"
  },
  YYY: {
    year: "numeric"
  },
  YY: {
    year: "2-digit"
  },
  MMMM: {
    month: "long"
  },
  MMM: {
    month: "short"
  },
  MM: {
    month: "2-digit"
  },
  M: {
    month: "numeric"
  },
  DD: {
    day: "2-digit"
  },
  D: {
    day: "numeric"
  },
  dd: {
    weekday: "long"
  },
  d: {
    weekday: "short"
  },
  hh: {
    hour: "numeric",
    hour12: !1
  },
  h: {
    hour: "numeric",
    hour12: !1
  },
  HH: {
    hour: "numeric",
    hour12: !0
  },
  H: {
    hour: "numeric",
    hour12: !0
  },
  mm: {
    minute: "numeric"
  },
  m: {
    minute: "numeric"
  },
  ss: {
    second: "numeric"
  },
  s: {
    second: "numeric"
  }
},
    o = function () {
  function t(t) {
    return this.date = t, this;
  }

  var r = t.prototype;
  return r.format = function (t, r, e) {
    var n = r || "en",
        u = e ? n + "-u-ca-" + e : n,
        o = function (t) {
      return t.match(/\bY{2,4}\b|\bM{1,4}\b|\bD{1,2}\b|\bd{1,2}\b|\bh{1,2}\b|\bH{1,2}\b|\bm{1,2}\b|\bs{1,2}\b/g) || [];
    }(t),
        c = this.mapAvailableStringFormatToValue(o, u);

    return Object.keys(c).reduce(function (t, r) {
      var e = new RegExp("\\b" + r + "\\b", "g");
      return t.replace(e, c[r]);
    }, t);
  }, r.mapAvailableStringFormatToValue = function (t, r) {
    var e = this;
    return t.reduce(function (t, o) {
      return t[o] = function (t, r, e) {
        var o = t.toLocaleString(e, u[r]);
        return n.includes(r) ? o.padStart(2, "0") : o;
      }(e.date, o, r), t;
    }, {});
  }, t;
}();

exports.default = function () {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
    r[n] = arguments[n];
  }

  var u = r ? e(Date, r) : new Date();
  return new o(u);
};